export const V2Type = {
  Number: 'number',
  Artifact: 'artifact',
  Npi: 'npi',
  Reference: 'reference',
};

export const STATUS_CONFIG = {
  pending_verification: {
    label: 'Pending Verification',
    color: '#307F92',
  },
  /**
   * @deprecated Temporary status: backend should return 'pending_verification' instead of 'pending'
   */
  pending: {
    label: 'Pending Verification',
    color: '#307F92',
  },
  verified: { label: 'Verified', color: '#28a745' },
  invalid: { label: 'Invalid', color: '#d32f2f' },
  expired: { label: 'Expired', color: '#d32f2f' },
};

export const getStatusConfig = (status) =>
  STATUS_CONFIG[status] || { label: '-', color: '#6c757d' };


export const CredentialV2Enum  = {
  StateLicense: 'state_license',
  LocalAnesthesiaLicense: 'local_anesthesia_license',
  CprBls: 'cpr_bls',
  Reference: 'reference',
  Upload: 'upload',
  Npi: 'npi',
  // artifacts
  EFDACertification: 'efda_certification',
  DACertification: 'da_certification',
  Radiology: 'radiology',
  LocalAnesthesiaCertification: 'local_anesthesia_certification',
  CoronalPolishingCertification: 'coronal_polishing_certification',
  InfectionControlCertification: 'infection_control_certification',
  NitrousOxideCertification: 'nitrous_oxide_certification',
}

// `{state}_da_certification` / `{state}_efda_certification` (or unprefixed). Anchored
// on `_` so `efda_certification` never matches the DA rule via `includes`.
const PRIMARY_CERTIFICATION = /(^|_)(da|efda)_certification$/;

/**
 * The credential card that carries the authorization's CS name-change section:
 * the state licence number, or a DA/EFDA primary certification for
 * certification-only states (GOTU-8196). Secondary artifacts (CPR/BLS,
 * radiology, …), NPI and references never qualify.
 *
 * `confirmed_name` is per authorization, so this must match at most one card
 * per authorization; keep it identical to the mobile rule (GOTU-8194).
 */
export const isConfirmedNameCredential = (cred) => {
  const credential = typeof cred?.credential === 'string' ? cred.credential : '';
  if (cred?.type === V2Type.Number) {
    return credential.includes(CredentialV2Enum.StateLicense);
  }
  if (cred?.type === V2Type.Artifact) {
    return PRIMARY_CERTIFICATION.test(credential);
  }
  return false;
};

export const CREDENTIAL_TYPE_OPTIONS = [
  { code: 'state_license', name: 'State License' },
  { code: 'cpr_bls', name: 'CPR/BLS' },
  { code: 'radiology', name: 'Radiology' },
  { code: 'reference', name: 'Reference' },
  { code: 'npi_number', name: 'NPI Number' },
  { code: 'local_anesthesia_license', name: 'Local Anesthesia License' },
  { code: 'local_anesthesia_certification', name: 'Local Anesthesia Certification' },
  { code: 'coronal_polishing_certification', name: 'Coronal Polishing Certification' },
  { code: 'infection_control_certification', name: 'Infection Control Certification' },
  { code: 'nitrous_oxide_certification', name: 'Nitrous Oxide Certification' },
  { code: 'certification', name: 'Certification' },
];

export const CREDENTIAL_V2_VALUES = Object.values(CredentialV2Enum);

export const getCredentialType = (
  credential
) => (
    CREDENTIAL_V2_VALUES.find((value) => credential.includes(value)) ||
    credential
  );

export const getCredentialTypeName = (credential) => {
  if (!credential) return '-';
  const option = CREDENTIAL_TYPE_OPTIONS.find((opt) => credential.includes(opt.code));
  return option ? option.name : credential;
};